import moment, { MomentInput } from 'moment'
import { ContentDataFragment, isContentItem, isContentListItemFragment } from 'src/utils/ContentDataFragment'

import styles from './ContentTimestamp.module.css'

// const getAgoString = (date: MomentInput, abbreviate = false): string => {
//   const timeout = moment.utc(date)
//   if (abbreviate) {
//     return moment(timeout).locale('en-abbrv').fromNow(true)
//   }
//   return moment.utc(moment.now()).to(timeout)
// }

const getSpecificDate = (date: MomentInput | null): string | null => {
  if (!date) return null
  const timeout = moment.utc(date)
  return moment(timeout).format('MMM DD, YYYY')
}

export interface DateProps {
  content: ContentDataFragment
  fromPage?: string
}

export const getContentDate = (content: ContentDataFragment, fromPage: string = ''): string | null => {
  const isMaintained = isContentListItemFragment(content)
    ? content?.isMaintained
    : isContentItem(content)
      ? content.isMaintained
      : false
  const lastMaintainedAt = isContentListItemFragment(content)
    ? content?.lastMaintained
    : isContentItem(content)
      ? content.lastMaintainedAt
      : null
  let date = null

  if (fromPage === 'EnhancedResourcePagination') {
    if (isMaintained && lastMaintainedAt) {
      date = getSpecificDate(lastMaintainedAt)
    } else if (isMaintained) {
      date = 'Maintained'
    } else {
      date = getSpecificDate(
        isContentListItemFragment(content)
          ? content?.publishedTime
          : isContentItem(content)
            ? content.publishedTime
            : content.publishedDate,
      )
    }
  } else {
    if (lastMaintainedAt) {
      date = getSpecificDate(lastMaintainedAt)
    } else if (isMaintained) {
      date = 'Maintained'
    } else {
      date = getSpecificDate(
        isContentListItemFragment(content)
          ? content?.publishedTime
          : isContentItem(content)
            ? content.publishedTime
            : content.publishedDate,
      )
    }
  }

  return date
}

export const getContentDateLabel = (content: ContentDataFragment): string | null => {
  const isMaintained = isContentListItemFragment(content)
    ? content?.isMaintained
    : isContentItem(content)
      ? content.isMaintained
      : false
  const lastMaintainedAt = isContentListItemFragment(content)
    ? content?.lastMaintained
    : isContentItem(content)
      ? content.lastMaintainedAt
      : null
  let label = null
  if (isMaintained && lastMaintainedAt) {
    label = 'Maintained on'
  } else if (!isMaintained) {
    label = 'Published on'
  }
  return label
}

export const ContentTimestamp: React.FC<DateProps> = ({ content, fromPage = '' }) => {
  const date = getContentDate(content, fromPage)
  const label = getContentDateLabel(content)
  return date ? (
    <div className="text-[12px] flex items-center flex-wrap gap-1">
      {label && (
        <span className={styles.timezonelabelbackground}>
          <span className={styles.timezonelabel}>{label}</span>
        </span>
      )}
      <span className="whitespace-nowrap">{date}</span>
    </div>
  ) : null
}
